import {ImportingDataTypes} from "../../types";
import {createInvalidPartnerSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productsFromAnotherPartner,
    sections: [
        {
            sectionKey: "missingProductsFromPartnerFields",
            sectionTitle: "Missing Required Fields",
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: "partId",
                    label: "Part ID",
                    type: "input",
                    textFieldProps: {inputProps: {type: "number", min: 0}},
                    extractValue: (o) =>
                        o === null || o === undefined || String(o).trim() === ""
                            ? ""
                            : String(o).trim(),
                    modifyRow: (row, val) => ({
                        ...row,
                        partId: val ?? "",
                    }),
                },
                {
                    key: "partNumber",
                    label: "Part Number",
                    type: "input",
                    modifyRow: (row, val) => ({
                        ...row,
                        partNumber:
                            val != null && String(val).trim() !== ""
                                ? String(val).trim().toUpperCase()
                                : "",
                    }),
                },
            ],
        },
        createInvalidPartnerSection(),
    ],
};
